import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Phone, Instagram, X, MessageSquare } from 'lucide-react';
export function FloatingWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show widget after scrolling past hero
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-167">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-6 right-6 z-50 flex flex-col items-end" data-id="element-168">
          <AnimatePresence data-id="element-169">
            {isOpen && <motion.div initial={{
          opacity: 0,
          scale: 0.8,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.8,
          y: 20
        }} className="mb-4 bg-white rounded-2xl shadow-2xl border border-brand-beige p-2 flex flex-col gap-2" data-id="element-170">
                <a href="tel:+380964797313" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-171">
                  <div className="w-8 h-8 bg-brand-burgundy/10 rounded-full flex items-center justify-center" data-id="element-172">
                    <Phone className="w-4 h-4 text-brand-burgundy" data-id="element-173" />
                  </div>
                  Зателефонувати
                </a>
                <a href="https://t.me/username" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-174">
                  <div className="w-8 h-8 bg-[#0088cc]/10 rounded-full flex items-center justify-center" data-id="element-175">
                    <MessageCircle className="w-4 h-4 text-[#0088cc]" data-id="element-176" />
                  </div>
                  Telegram
                </a>
                <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-177">
                  <div className="w-8 h-8 bg-[#E1306C]/10 rounded-full flex items-center justify-center" data-id="element-178">
                    <Instagram className="w-4 h-4 text-[#E1306C]" data-id="element-179" />
                  </div>
                  Instagram
                </a>
              </motion.div>}
          </AnimatePresence>

          <button onClick={() => setIsOpen(!isOpen)} className="w-14 h-14 bg-brand-burgundy text-white rounded-full shadow-lg flex items-center justify-center hover:bg-brand-burgundy/90 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-burgundy" aria-label="Contact options" data-id="element-180">
            {isOpen ? <X className="w-6 h-6" data-id="element-181" /> : <MessageSquare className="w-6 h-6" data-id="element-182" />}
          </button>
        </motion.div>}
    </AnimatePresence>;
}